import { render, staticRenderFns } from "./HbTabs.vue?vue&type=template&id=ff49ecca&scoped=true&"
import script from "./HbTabs.vue?vue&type=script&lang=js&"
export * from "./HbTabs.vue?vue&type=script&lang=js&"
import style0 from "./HbTabs.vue?vue&type=style&index=0&id=ff49ecca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff49ecca",
  null
  
)

export default component.exports